import { MonoTypeOperatorFunction } from "rxjs";
import { distinctUntilChanged } from "rxjs/operators";

export function distinctUntilArrayItemChanged<T>(): MonoTypeOperatorFunction<T[]> {
	return distinctUntilChanged((prevCollection: T[], currentCollection: T[]) => {
		if (!prevCollection) {
			return false;
		}

		if (prevCollection === currentCollection) {
			return true;
		}

		if (prevCollection.length !== currentCollection.length) {
			return false;
		}

		const isOneOfItemReferenceChanged = currentCollection.some((item, i) => prevCollection[i] !== item);

		// return false means there is a change, and we want to call next()
		return !isOneOfItemReferenceChanged;
	});
}

/*eslint-disable*/
export function distinctUntilDictItemChanged<T extends Record<any, any> | undefined>(): MonoTypeOperatorFunction<
	T | undefined
> {
	return distinctUntilChanged((prevCollection: T | undefined, currentCollection: T | undefined) => {
		if (!prevCollection) {
			return false;
		}

		if (prevCollection === currentCollection) {
			return true;
		}

		if (Object.keys(prevCollection).length !== Object.keys(currentCollection).length) {
			return false;
		}

		const isOneOfItemReferenceChanged = Object.values(currentCollection).some((item) => {
			return prevCollection[item.id] !== item;
		});

		// return false means there is a change, and we want to call next()
		return !isOneOfItemReferenceChanged;
	});
}
